import { getStoredSessionToken } from '../../../app/services/session.service';

const API_BASE_URL = (process.env.REACT_APP_DOCUMENTS_API_BASE_URL || '').replace(/\/$/, '');
const API_PATH = '/api/documents/custom-fields';

function authHeaders(extraHeaders = {}) {
  const token = getStoredSessionToken();
  return token ? { ...extraHeaders, Authorization: `Bearer ${token}` } : extraHeaders;
}

async function readPayload(response) {
  return response.json().catch(() => null);
}

function endpoint(formKey, suffix = '') {
  return `${API_BASE_URL}${API_PATH}/${encodeURIComponent(formKey)}${suffix}`;
}

export async function listDocumentsCustomFields(formKey) {
  const response = await fetch(endpoint(formKey), { headers: authHeaders() });
  const payload = await readPayload(response);
  if (!response.ok) throw new Error(payload?.message || 'Campi personalizzati non disponibili.');
  return Array.isArray(payload) ? payload : [];
}

export async function createDocumentsCustomField(definition, formKey) {
  const response = await fetch(endpoint(formKey), {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(definition),
  });
  const payload = await readPayload(response);
  return response.ok
    ? { ok: true, data: payload }
    : { ok: false, error: 'CUSTOM_FIELD_CREATE_FAILED', message: payload?.message || 'Impossibile salvare il campo.' };
}

export async function archiveDocumentsCustomField(id, formKey) {
  const response = await fetch(endpoint(formKey, `/${encodeURIComponent(id)}`), {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const payload = await readPayload(response);
  return response.ok
    ? { ok: true }
    : { ok: false, error: 'CUSTOM_FIELD_ARCHIVE_FAILED', message: payload?.message || 'Impossibile archiviare il campo.' };
}
